import React from 'react';
import styled from 'styled-components';
import { DEVICES } from '../../const';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';


const Container = styled.div`
  background-image:	url("https://kangaroo-edu-main.s3.ap-northeast-2.amazonaws.com/landing-page/home/strength_header.jpg");
  background-size: cover;
  background-position: 52% 54%;
  position: relative;
  text-align: center;

  @media ${DEVICES.mobile} {
    height: 500px;
  }

  @media ${DEVICES.tablet} {
    height: 700px;
  }

  @media ${DEVICES.large} {
    height: 700px;
  }
`;

const ImageWrapper = styled.div`
  position: absolute;
  background-color: rgba(35, 46, 43, 0.89);
  width: 100%;
  height: 100%;
  @media ${DEVICES.mobile} {
    padding: 100px 0;
  }

  @media ${DEVICES.tablet} {
    padding: 200px 0;
  }

  @media ${DEVICES.large} {
    padding: 200px 0;
  }
`;

const Heading = styled.div`
  color: #fff;
  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1.2rem;
  }

  @media ${DEVICES.large} {
  }
`;

const Title = styled.div`
  color: #fff;
  line-height: 64px;
  line-height: 1;
  @media ${DEVICES.mobile} {
    font-size: 1.8rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 2.5rem;
  }

  @media ${DEVICES.large} {
    font-size: 3rem;
  }
`;

const TitleBold = styled.div`
  color: #fff;
  font-weight: 700;
  margin-top: 1.5rem;
  @media ${DEVICES.mobile} {
    font-size: 1.8rem;
    line-height: 48px;
  }

  @media ${DEVICES.tablet} {
    font-size: 2.5rem;
    line-height: 64px;
  }

  @media ${DEVICES.large} {
    font-size: 3rem;
  }
`;

const Description = styled.div`
  color: #fff;
  margin-top: 40px;
  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1.2rem;
  }

  @media ${DEVICES.large} {
  }
`;

const IconWrapper = styled.div`
  margin-top: 2.5rem;
  color: #fff;
`;

export default function StrengthHeaderBanner() {
  return <Container>
    <ImageWrapper>
      <Heading>
        체계적인 프로그램을 통해
      </Heading>
      <TitleBold>
        긍정적인 변화를
      </TitleBold>
      <Title>
        이끌어내겠습니다
      </Title>
      <Description>
        캥거루짐만의 강점을 소개해드리겠습니다
      </Description>
      <IconWrapper>
        <KeyboardArrowDownIcon fontSize='large' />
      </IconWrapper>
    </ImageWrapper>
  </Container>
}
